// RD-20261011 §3-3 — 점프바 항목은 «렌더된 h2» 에서 만든다. 수동 목록 금지(G9: 점프바 a 수 = h2 수).

export interface HeadingLike {
  id: string;
  text: string;
  /** VX-2 REQ_L40 ② — h2 의 `data-jump-label`(있으면). 칩 글자만 바꾼다 — id·앵커·칩 수는 그대로. */
  jumpLabel?: string | null;
}

export interface JumpEntry {
  id: string;
  label: string;
}

/** 헤딩 목록 → 점프바 항목. id·텍스트가 없는 헤딩은 건너뛰고 같은 id 는 한 번만 센다.
 *  칩 글자 = jumpLabel(data-jump-label)이 있으면 그것, 없으면 h2 글자 그대로. 글자가 빈 h2 는 jumpLabel 이 있어도 건너뛴다(칩 수 = 보이는 h2 수 · G9). */
export function jumpItemsFromHeadings(headings: HeadingLike[]): JumpEntry[] {
  const seen = new Set<string>();
  const out: JumpEntry[] = [];
  for (const h of headings) {
    const id = (h.id || '').trim();
    const text = (h.text || '').replace(/\s+/g, ' ').trim();
    if (!id || !text || seen.has(id)) continue;
    seen.add(id);
    const short = (h.jumpLabel || '').replace(/\s+/g, ' ').trim();
    out.push({ id, label: short || text });
  }
  return out;
}

/** id 가 없는 h2 에 붙일 앵커. 한글 유지, 구분은 하이픈. 충돌하면 -2, -3. */
export function headingId(text: string, taken: Set<string>): string {
  const slug = (text || '').trim().toLowerCase().replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '');
  const base = slug ? `rd-${slug}` : 'rd-sec';
  let id = base;
  let n = 2;
  while (taken.has(id)) id = `${base}-${n++}`;
  taken.add(id);
  return id;
}
